import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

const withLocation = (WrappedComponent) => {
    const WithLocation = (props) => {
        const location = useLocation();
        const params = useParams();
        return <WrappedComponent {...props} location={location} params={params} />;
    };
    WithLocation.initialAction = WrappedComponent.initialAction;
    return WithLocation;
};

export default withLocation;
